<template>
  <div style="width: 100%">
    <div
      class="form__input form__input--more"
      :class="data.none ? 'form__input--disabled' : ''"
    >
      <p>
        <img v-if="img" :src="img" alt="" />
        <input
          type="text"
          :data-id="input_id"
          v-model="input"
          @input="change"
          @blur="blur"
        />
      </p>
      <span style="min-height:15px">{{ data.name }}</span>
      <div v-if="hidden != false">
        <a
          class="icon icon-more"
          v-if="!data.none"
          @click.prevent="openList(data.mod)"
        ></a>
        <a class="form__close" v-if="input" @click.prevent="cliner"></a>
      </div>
      <transition name="fade">
        <ul class="form__input__autocomplete" v-if="dropdown">
          <li
            v-for="(item, index) in arr"
            :key="index"
            style="display:flex"
            @click.prevent="autocompleteClick(item.id, item.name, item.phone, item.doc_support_manager_id, item.doc_support_manager_name, item.country_code)"
          >
            <img v-if="item.country_code && data.mod == 'city'" style="width:17px;height:13px;margin-right:5px;margin-top:3px" :src="'https://democrm-sss.soft-pro.biz/img/flags/' +item.country_code.toLowerCase() + '.svg'" />{{ item.name }}
          </li>
          <li v-if="quantityList == '0'">{{$root.langText.notFoundMin}}</li>
          <li v-if="quantityList > '5'" style="color: red; font-size: 13px">
            {{$root.langText.firstFive}}
          </li>
        </ul>
      </transition>
    </div>
    <Clients :popup="clients" @close="closeList" v-if="clients" />
    <Counterparties
      :popup="counterparties"
      :data="data"
      @close="closeList"
      v-if="counterparties"
    />
    <City :popup="city" @close="closeCity" v-if="city" />
    <Team :popup="team" @close="closeList" v-if="team" />
    <LegalPersons
      :data="data"
      :popup="legalPersons"
      @close="closeList"
      v-if="legalPersons"
    />
    <ClientsSource
      :popup="clientsSource"
      @close="closeList"
      v-if="clientsSource"
    />
    <CounterpartiesGroup
      :popup="counterpartiesGroup"
      @close="closeList"
      v-if="counterpartiesGroup"
    />
    <Services :popup="services" @close="closeList" v-if="services" />
    <CarType :popup="carType" @close="closeList" v-if="carType" />
    <Drivers :data="data" :popup="drivers" @close="closeList" v-if="drivers" />
    <Car :data="data" :popup="car" @close="closeList" v-if="car" />
    <All :popup="all" :mod="data.modType" @close="closeList" v-if="all" />
    <Trailers
      :data="data"
      :popup="trailers"
      @close="closeList"
      v-if="trailers"
    />
    <Contact
      :hidden="hidden"
      :popup="contact"
      :data="data"
      @close="closeList"
      v-if="contact"
    />
    <Countries :popup="countries" @close="closeCity" v-if="countries" />
  </div>
</template>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.form__input--more input {
  padding-right: 40px;
}
.form__input__autocomplete {
  max-height: 200px;
}
.form__input__autocomplete li {
  padding: 6px 4px;
  box-shadow: none;
  margin-bottom: 0;
}
</style>


<script>
import Clients from "@/components/selection/Clients";
import Counterparties from "@/components/selection/Counterparties";
import City from "@/components/selection/City";
import Team from "@/components/selection/Team";
import LegalPersons from "@/components/selection/LegalPerson";
import ClientsSource from "@/components/selection/ClientsSource";
import CounterpartiesGroup from "@/components/selection/CounterpartiesGroup";
import Services from "@/components/selection/Services";
import CarType from "@/components/selection/CarType";
import Drivers from "@/components/selection/Drivers";
import Car from "@/components/selection/Car";
import Trailers from "@/components/selection/Trailers";
import Contact from "@/components/selection/Contact";
import Countries from "@/components/selection/Countries";
import All from "@/components/selection/All";

export default {
  name: "Autocomplete",
  props: ["data", "hidden"],

  data: () => ({
    input: null,
    input_id: "",
    arr: [],
    dropdown: false,
    img: "",
    //popup
    clients: false,
    counterparties: false,
    city: false,
    team: false,
    legalPersons: false,
    clientsSource: false,
    counterpartiesGroup: false,
    services: false,
    carType: false,
    drivers: false,
    car: false,
    all: false,
    trailers: false,
    contact: false,
    countries: false,

    //pagination
    check: "",

    quantityList: "",
    params: {
      start: 0,
      limit: 5,
    },
  }),

  watch: {
    data: function () {
      // this.input = this.data.input;
      // this.check = this.input;
      // this.input_id = this.data.inputId;
      // if (this.data.img) {
      //   this.img =
      //     "https://democrm-sss.soft-pro.biz/img/flags/" +
      //     this.data.img.toLowerCase() +
      //     ".svg";
      // }
    },
  },

  created() {
    this.input = this.data.input;
    this.check = this.input;
    this.input_id = this.data.inputId;
    if (this.data.img) {
      this.img =
        "https://democrm-sss.soft-pro.biz/img/flags/" +
        this.data.img.toLowerCase() +
        ".svg";
    }
  },
  methods: {
    //cliner
    cliner() {
      var input = this.data.key;
      this.input = "";
      this.input_id = "";
      this.check = "";
      this.img = "";
      this.$emit("result", { id: "", name: "", input, img: "" });
    },

    //data
    async change() {
      if (this.input.length >= 3) {
        var data = "search=" + this.input;
        var dispatch;

        if(this.data.mod == "contact" && this.data.idClient){
          var id = this.data.idClient
          var type = this.data.typeClient
          const contact = await this.$store.dispatch('getContactsPersons', {id, type, data});
          var app = this
          app.arr = []
          contact.data.list.forEach(function(item, index){
            if(item.id && index <= 4){
              app.arr.push(item)
            }
          })
          this.quantityList = this.arr.length
        }else {
          if(this.data.idContractor){
            data += '&f[contractor_id]='+this.data.idContractor
          }

          //clients
          if (this.data.mod == "clients") {
            dispatch = "postFiltersClients";
          }

          //counterparties
          if (this.data.mod == "counterparties") {
            if (this.data.filter) {
              data += "&f[" + this.data.filter + "]=1";
            }
            if (this.data.idClient) {
              data += "&f[client_id]=" + this.data.idClient;
            }
            if (this.data.idMainContractor) {
              data += "&f[main_contractor]=" + this.data.idMainContractor;
            }
            dispatch = "postFiltersСounterparties";
          }

          //city
          if (this.data.mod == "city") {
            dispatch = "postFiltersCity";
          }
          
          //team
          if (this.data.mod == "team") {
            dispatch = "postFiltersTeam";
          }

          //legalPersons
          if (this.data.mod == "legalPersons") {
            dispatch = "postFiltersLegalPerson";
          }

          //clientsSource
          if (this.data.mod == "clientsSource") {
            dispatch = "postFiltersClientsSource";
          }

          //counterpartiesGroup
          if (this.data.mod == "counterpartiesGroup") {
            dispatch = "postFiltersСounterpartiesGroup";
          }

          //services
          if (this.data.mod == "services") {
            if(this.$root.app == 'SoftProCrmAppRioTransTest' || this.$root.app == 'SoftProCrmAppRioTrans'){
              data += '&f[service_group]=0&f[service_type]=1'
            }
            dispatch = "postFiltersServices";
          }
          
          //car
          if (this.data.mod == "car") {
            dispatch = "postFiltersCar";
          }

          //carType
          if (this.data.mod == "carType") {
            dispatch = "postFiltersCarType";
          }

          //drivers
          if (this.data.mod == "drivers") {
            dispatch = "postFiltersDrivers";
          }

          //trailers
          if (this.data.mod == "trailers") {
            dispatch = "postFiltersTrailers";
          }

          //countries
          if (this.data.mod == "countries") {
            dispatch = "postFiltersCountry";
          }



          /// demo
          if (this.data.modType == "car") {
            dispatch = "postFiltersCar";
          }
          if(this.data.modType == 'org'){
            dispatch = 'getOrg'
          }
          if(this.data.modType == 'line'){
            dispatch = 'getlines'
          }
          if(this.data.modType == 'courtAction'){
            dispatch = 'courtAction'
          }
          if(this.data.modType == 'carModels'){
            dispatch = 'carModels'
          }
          if(this.data.modType == 'carManufacturers'){
            dispatch = 'carManufacturers'
          }
          if(this.data.modType == 'servicesName'){
            dispatch = 'servicesName'
          }
          if(this.data.modType == 'incomeNDS'){
            dispatch = 'incomeNDS'
          }
          if(this.data.modType == 'paymentTypes'){
            dispatch = 'paymentTypes'
          }
          if(this.data.modType == 'conditions'){
            dispatch = 'conditions'
          }
          if(this.data.modType == 'cargo'){
            dispatch = 'cargo'
          }
          if(this.data.modType == 'route'){
            dispatch = 'route'
          }

          var res = await this.$store.dispatch(dispatch, {
            params: this.params,
            data: data,
          });

          this.arr = res.data.list;
          this.quantityList = res.data.total_num;
        }


        this.dropdown = true;
      } else {
        this.dropdown = false;
      }
    },

    blur() {
      if(this.check !== this.input) {
        this.input = this.check;
        this.dropdown = false;

        var input = this.data.key;
        this.$emit("result", { id: this.input_id, name: this.input, input });
      }
    },

    autocompleteClick(id, name, phone, doc_menedger_id, doc_menedger_name, img) {
      this.input = name;
      this.input_id = id;
      this.dropdown = false;

      var input = this.data.key;
      if (phone && this.data.mod == "drivers" || this.data.mod == "contact") {
        this.$emit("result", { id, name, input, phone: phone });
      } else if (doc_menedger_id && doc_menedger_id !== "0") {
        this.$emit("result", {
          id,
          name,
          input,
          doc_menedger_id,
          doc_menedger_name,
        });
      } else if(img){
        this.img =
        "https://democrm-sss.soft-pro.biz/img/flags/" +
        img.toLowerCase() +
        ".svg";
        this.$emit("result", {
          id,
          name,
          input,
        });
      } else {
        this.$emit("result", { id, name, input });
      }
    },

    //popup list
    openList(component) {
      if (component == "clients") {
        this.clients = !this.clients;
      }
      if (component == "counterparties") {
        this.counterparties = !this.counterparties;
      }
      if (component == "city") {
        this.city = true;
      }
      if (component == "team") {
        this.team = true;
      }
      if (component == "legalPersons") {
        this.legalPersons = true;
      }
      if (component == "clientsSource") {
        this.clientsSource = true;
      }
      if (component == "counterpartiesGroup") {
        this.counterpartiesGroup = true;
      }
      if (component == "services") {
        this.services = true;
      }
      if (component == "car") {
        this.car = true;
      }
      if (component == "all") {
        this.all = true;
      }
      if (component == "carType") {
        this.carType = true;
      }
      if (component == "drivers") {
        this.drivers = true;
      }
      if (component == "trailers") {
        this.trailers = true;
      }
      if (component == "contact" && this.data.idClient) {
        this.contact = true;
      }
      if (component == "countries") {
        this.countries = true;
      }
      // this.$root.overflowApp.flag = true
    },
    closeList(data) {
      this.clients = false;
      this.counterparties = false;
      this.team = false;
      this.legalPersons = false;
      this.clientsSource = false;
      this.counterpartiesGroup = false;
      this.services = false;
      this.carType = false;
      this.drivers = false;
      this.car = false;
      this.all = false;
      this.trailers = false;
      this.contact = false;
      this.countries = false;
      // this.$root.overflowApp.flag = false
      if (data) {
        //data
        this.input = data.name;
        this.input_id = data.id;
        this.check = data.name;

        var input = this.data.key;
        var name = data.name;
        var id = data.id;
        var doc_menedger_id = data.doc_menedger_id;
        var doc_menedger_name = data.doc_menedger_name;
        if (data.phone) {
          this.$emit("result", { id, name, input, phone: data.phone });
        } else if (data.doc_menedger_id && data.doc_menedger_id !== "0") {
          this.$emit("result", {
            id,
            name,
            input,
            doc_menedger_id,
            doc_menedger_name,
          });
        } else {
          this.$emit("result", { id, name, input, data: data.item });
        }
      }
    },
    closeCity(data) {
      if (data) {
        this.input = data.name;
        this.input_id = data.id;
        if (data.img) {
          this.img =
            "https://democrm-sss.soft-pro.biz/img/flags/" + data.img + ".svg";
        } else {
          this.img = "";
        }
        this.$emit("result", {
          id: data.id,
          name: data.name,
          input: this.data.key,
          img: this.img,
        });
      }
      this.city = false;
      this.countries = false;
    },
  },
  components: {
    Clients,
    Counterparties,
    City,
    Team,
    LegalPersons,
    ClientsSource,
    CounterpartiesGroup,
    Services,
    CarType,
    Car,
    Trailers,
    Contact,
    Countries,
    Drivers,
    All,
  },
};
</script>